var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contactUs"},[_c('div',{staticClass:"contact-card"},[_c('div',{staticClass:"contact-card-notice"},[_vm._v(" 我们重视您对服务的每一声问询，提供服务查询、咨询，信息反馈、投诉及建议等服务内容。如有需要您可以联系我们。 ")]),_c('div',{staticClass:"phone-number"},[_c('span',[_vm._v("热线电话：")]),_c('a',[_vm._v("88585518")])])])])
}]

export { render, staticRenderFns }